import { Token } from "../../../store/global/TokenEnum";
import React from "react";
import { TokensBoughtOrSold } from "./TokensBoughtOrSold";
import { TokenHistoryInfo } from "../../../types/history";
import { FlexContainer } from "../../../containers/FlexContainer";
import { FlexColumnBetween } from "../../general/FlexColumnBetween/FlexColumnBetween";
import { Direction, TokenStackedArray } from "components/general/TokenStackedArray";
import styled from "@emotion/styled";
import { useIsTradeHistoryReturned } from "../../../hooks/useIsTradeHistoryReturned";
import { SkeletonCircle } from "../../general/Skeleton";

export interface BuyTokensCellProps {
  tokenHistoryInfo: TokenHistoryInfo;
  columnId: string;
}

export const BuyTokensOrSellTokensCell: React.FC<BuyTokensCellProps> = React.memo(
  ({ tokenHistoryInfo }) => {
    const tokens = Object.keys(tokenHistoryInfo) as Array<Token>;
    const isTradeHistoryReturned = useIsTradeHistoryReturned();
    return (
      <FlexContainer>
        <FlexColumnBetween>
          {isTradeHistoryReturned ? (
            <TokenStackedArray direction={Direction.Vertical} tokens={tokens} tokenSize={28} />
          ) : (
            <SkeletonIcon>
              <SkeletonCircle />
            </SkeletonIcon>
          )}
        </FlexColumnBetween>
        <TokensBoughtOrSold tokenHistoryInfo={tokenHistoryInfo} />
      </FlexContainer>
    );
  }
);

// Sub-components

const SkeletonIcon = styled.div`
  width: 25px;
  height: 25px;
`;
